import * as React from "react";
import PageBreaker from "./PageBreaker";
import moment from "moment";
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";

const CoverPage = (props) => {
  const { portfolio, app } = props;
  const logo = app.logoColored || app.logo;
  const { name, onboardStatus, cprRecommendation, advisors } =
    portfolio;
  const isDraft = onboardStatus === "in-review";
  const portfolioId = portfolio.uuid;
  let Clients = portfolio.clientProfiles ?
    portfolio.clientProfiles.map(c => ({profile: c})) :
    portfolio.Clients;
  Clients = Clients.sort((c1, c2) => c1.profile.primary === true && c2.profile.primary === false ? -1 : 1);

  return (
    <div className={"page cover-page"}>
      <div className={"cover-page-shadow-top"} />
      <div className={"cover-page-shadow-bottom"} />
      <div className={"logo"}>
        { logo && <img alt="App Logo" src={logo} /> }
        { app.customizedTheme &&
          <Typography variant={'body1'} style={{fontSize: '9pt'}}>Powered by Cy</Typography>
        }
      </div>
      <Grid
        container={true}
        style={{ padding: "0.2in 0.7in 0" }}
      >
        <Grid item xs={12} style={{ marginBottom: "0.8in" }}>
          <Typography variant={"h1"} style={{ marginBottom: "0.4in" }}>
            Cy Optimized Portfolio Summary
          </Typography>
          <Typography variant={'body1'} style={{fontSize: '9pt'}}>Portfolio Name</Typography>
          <Typography variant={"h2"}>{name}</Typography>
          <Typography variant={'body1'} style={{fontSize: '9pt', marginTop: '6pt'}}>Strategy</Typography>
          <Typography variant={"h3"}>
            {cprRecommendation.displayName}
          </Typography>
          {isDraft && (
            <Typography variant={"h4"} style={{ opacity: 0.6 }}>
              Draft
            </Typography>
          )}
        </Grid>
        <Grid item={true} xs={4}>
          <Typography variant={"h5"} style={{ opacity: 0.7 }}>
            Prepared For
          </Typography>
          <Typography variant={"body1"}>
            {`${Clients[0].profile.firstName} ${Clients[0].profile.lastName}`}
            {Clients.length > 1 && (
              <React.Fragment>
                &nbsp;and&nbsp;{Clients[1].profile.firstName}&nbsp;
                {Clients[1].profile.lastName}
              </React.Fragment>
            )}
            <br />
            {Clients[0].profile.streetAddress}
            <br />
            {Clients[0].profile.city}, {Clients[0].profile.state}
            <br />
            {Clients[0].profile.zipCode}
            <br />
            {Clients[0].profile.phone}
            <br />
            {Clients[0].profile.email}
            <br />
            <br />
            {moment().format("MMM DD, YYYY")}
          </Typography>
        </Grid>
        <Grid item={true} xs={4}>
          <Typography variant={"h5"} style={{ opacity: 0.7 }}>
            Prepared By
          </Typography>
          <Typography variant={"body1"}>
            {advisors.length && (
              <React.Fragment>
                {advisors[0].first_name}&nbsp;{advisors[0].last_name}
                <br />
                {advisors[0].phone}
                <br />
                {advisors[0].email}
              </React.Fragment>
            )}
          </Typography>
        </Grid>
        <Grid item={true} xs={4} />
        <Grid item={true} xs={12}>
          <Typography style={{marginTop: '0.2in', lineHeight: 1.2}}>
            This portfolio summary is produced for your reference as an output of your use of the WBI Cy
            Platform with your introducing adviser. The platform has interactive tools that allow Clients
            and Introducing Advisers to review and analyze a variety of simulations and projected outcomes
            if an investment was made in certain investment strategies. This summary does not represent
            every simulation or investment strategy that was analyzed. Instead, it reflects only
            the final portfolio that was determined by the Client and Introducing Adviser to be the most
            appropriate option given the Clients' unique circumstances.
          </Typography>
        </Grid>
      </Grid>
      <div className={"copyright"}>
        <Typography variant={"caption"}>
          Copyright {moment().year()} CyborgTech, LLC
        </Typography>
        <br />
        {!isDraft && <Typography variant={"caption"}>{portfolioId}</Typography>}
      </div>
      <PageBreaker />
    </div>
  );
};


export default CoverPage;



// WEBPACK FOOTER //
// ./src/containers/SummaryPDF/components/CoverPage.jsx